import { useState, useEffect, useRef, useCallback} from 'react';
import {  differenceInMinutes, fromUnixTime, getUnixTime } from 'date-fns';
import Popup from './common/components/popup';

const SessionTimeout = () => {
    const [showModal, setShowModal] = useState(false);

    const warningInactiveInterval = useRef<NodeJS.Timeout>();
    const startTimerInterval = useRef<NodeJS.Timeout>();

    //check if the user is idle
    const timeChecker = useCallback(() => {
        startTimerInterval.current = setTimeout(() => {
            const storedTimeStamp = sessionStorage.getItem('lastTimeStamp') || '';
            if (warningInactiveInterval.current) {
                clearInterval(warningInactiveInterval.current);
            }
            warningInactive(storedTimeStamp);
        }, 60000); //keep check after a minute of event
    }, []);

    // check if timeout is happened
    const warningInactive = (timeString: string) => {
        if (startTimerInterval.current) {
            clearTimeout(startTimerInterval.current);
        }

        warningInactiveInterval.current = setInterval(() => {
            const now = new Date().getTime();
            const storedTime = Number(timeString);

            const storedDateTime = fromUnixTime(getUnixTime(storedTime));
            const currentDateTime = fromUnixTime(getUnixTime(now));

            const minPast = differenceInMinutes(currentDateTime, storedDateTime);

            if (minPast >= 20)
            {
                setShowModal(true);
            }
        }, 1000);// keep check every second
    };

    // reset interval timer
    const resetTimer = useCallback(() => {
        if (startTimerInterval.current) {
            clearTimeout(startTimerInterval.current);
        }
        if (warningInactiveInterval.current) {
            clearInterval(warningInactiveInterval.current);
        }

        const timeStamp = new Date().getTime();

        sessionStorage.setItem('lastTimeStamp', timeStamp.toString());

        timeChecker();
        setShowModal(false);
    }, [timeChecker]);

    useEffect(() => {
        const events = ['click', 'load', 'scroll'];
        events.forEach((event) => {
            window.addEventListener(event, resetTimer);
        });

        const timeStamp = new Date().getTime();
        sessionStorage.setItem('lastTimeStamp', timeStamp.toString());
        timeChecker();

        return () => {
            if (startTimerInterval.current) {
                clearTimeout(startTimerInterval.current);
            }
            events.forEach((event) => {
                window.removeEventListener(event, resetTimer);
            });
        };
    }, [resetTimer, timeChecker]);

    return (
        <Popup
            showModal={showModal}
        />
    )
};

export default SessionTimeout;

